import React from 'react';
import { connect } from 'redux-bundler-react';
import ProjectButton from './project-button';

class ProjectButtons extends React.Component {
  render(){
    const { openProjects } = this.props;
    return (
      <div>
        {
          Object.keys(openProjects).map((type) => {
            return Object.keys(openProjects[type]).map((libraryId)=> {
              return <ProjectButton library={openProjects[type][libraryId]} dsType={type} key={`${type}-${libraryId}`} />
            })
            
          })
        }
      </div>
    )
  }
}

export default connect(
  'selectOpenProjects',
  ProjectButtons
)